export default __webpack_public_path__ + "static/media/f0022-01.ffe620f4.png";